import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import { LogIn } from 'lucide-react';

const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await login(email, password);
      navigate(data.role === 'admin' ? '/portal/admin' : '/portal/dashboard');
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="portal-login-page" data-testid="login-page">
      <div className="portal-login-card">
        <div className="portal-login-header">
          <LogIn size={32} />
          <h1>Client Portal</h1>
          <p>Log in to access your training dashboard</p>
        </div>
        <form onSubmit={handleSubmit} className="portal-login-form">
          {error && <div className="portal-error" data-testid="login-error">{error}</div>}
          <div className="portal-field">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              data-testid="login-email"
              placeholder="your@email.com"
            />
          </div>
          <div className="portal-field">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              data-testid="login-password"
              placeholder="Enter your password"
            />
          </div>
          <button type="submit" disabled={loading} className="portal-btn-primary" data-testid="login-submit">
            {loading ? 'Logging in...' : 'Log In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
